<template>
	<div class="comments">
    <van-row class="my_message">
      <van-col span="24" v-if="is_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="my_message_type">
              <van-col span="24" class="my_message_time">{{ t.addtime }}</van-col>
              <van-col span="4">
                <van-image width="3.5em" height="3.5em" :src="system_log" fit="cover"/>
              </van-col>
              <van-col span="17" class="my_message_center_jiao">
                <van-col span="24" class="my_message_center">{{ t.centent }}</van-col>
              </van-col>
              <van-col span="3" class="my_message_sel" v-if="t.url" @click="jump(t.url)">{{ $t('other.see')}}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="24" class="no-data">
          <img src="../assets/img/zwsl.png"/>
        </van-col>
        <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
      </van-col>
    </van-row>
	</div>
</template>
<script>
  import '@/assets/css/style.css'
	import axios from 'axios'
  import Toast from "vant/lib/toast";
	export default {
		data() {
			return {
        finished: false,
        loading: false,
				list:[],
        is_list:true,
        page:1,
        system_log:'',
			}
		},
		created: function() {
		  this.list = []
		  this.config()
			this.convert()
			document.title = this.$t('title.system_message')
		},
		methods: {
      onLoad() {
        this.convert()
      },
		  config: function(){
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/app_api/vue_config").then(res => {
          console.log(res.data.list);
          this.system_log = res.data.data.system_log;
        })
      },
			convert: function() {
				const uid = this.$route.query.uid;
				const token = this.$route.query.token;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/system_message_api/get_system_messages",{ params:{ uid:uid,token:token,page: this.page }}).then(res => {
					console.log(res.data.list);
          if (res.data.code == 1) {
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                this.list.push(res.data.list[i])
              }
              this.is_list = true
              this.page = this.page + 1
              this.loading = false
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              this.finished =true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
				})
			},
      jump(url) {
        window.location.href=url;
      }
		}
	}
</script>




// WEBPACK FOOTER //
// src/components/system_message.vue